import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang, copy } from "@/i18n";

export default function LegalPage({ kind }) {
  const { lang } = useLang();
  const doc = copy[lang].legal[kind];

  return (
    <div
      data-testid={`legal-${kind}`}
      className="min-h-screen px-6 md:px-14 pt-32 pb-24 text-center"
      style={{ background: "#050505" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl mx-auto space-y-8"
      >
        <Link to="/" data-testid="legal-back-link">
          <img
            src="/fmf-logo-white.png"
            alt="FMF"
            className="w-16 mx-auto opacity-90"
          />
        </Link>
        <h1
          data-testid="legal-title"
          className="font-mono-fmf text-xl md:text-2xl uppercase tracking-[0.35em] text-white"
        >
          {doc.title}
        </h1>
        {doc.paras.map((p, i) => (
          <p
            key={i}
            data-testid={`legal-para-${i}`}
            className="text-sm md:text-base font-light leading-loose text-white"
          >
            {p}
          </p>
        ))}
      </motion.div>
    </div>
  );
}
